var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23545 0V12H6.58836L3.29418 8.8V3.2L6.58836 0H8.23545ZM2.47064 3.2V8.8H1.23532C0.558607 8.8 0.0110469 8.27467 0.000167708 7.61988L0 7.6V4.4C0 3.74264 0.540794 3.21073 1.21485 3.20016L1.23532 3.2H2.47064ZM13.0517 3.69743L14 4.61772L12.578 5.99904L14 7.38034L13.0517 8.30151L11.6307 6.9202L10.2087 8.30151L9.26042 7.38035L10.6824 5.99904L9.26042 4.61772L10.2087 3.69743L11.6307 5.07874L13.0517 3.69743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioOff);
export default __webpack_public_path__ + "static/media/icon_audio_off.66c420e7c0ab36fb50baf4de5291719a.svg";
export { ForwardRef as ReactComponent };